import { hotTags, exposeCards } from '@/mocks/homepage';

export default function ExposeGrid() {
  return (
    <section id="expose-grid" className="py-10 md:py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-foreground-950 tracking-tight">
              <strong>最新爆料</strong>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 whitespace-nowrap">
            今日已更新 127 条爆料 · 滑动查看更多
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-8">
          {hotTags.map((tag) => (
            <span
              key={tag.id}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer transition-colors whitespace-nowrap ${
                tag.label === '爆'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              {tag.label}
            </span>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {exposeCards.map((card) => (
            <a
              key={card.id}
              href={`/article/${card.id}`}
              className="group block rounded-xl overflow-hidden bg-background-100 hover:-translate-y-1 transition-all duration-300"
              title={`查看爆料：${card.title}`}
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.title} - ${card.category}爆料`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 right-3">
                  <span
                    className={`px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap ${
                      card.tag === '爆'
                        ? 'bg-primary-500 text-background-50'
                        : card.tag === '独家'
                          ? 'bg-background-50 text-primary-500 border border-primary-300'
                          : 'bg-accent-500 text-background-50'
                    }`}
                  >
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-foreground-950/80 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="text-[10px] text-background-50/70 uppercase tracking-wider mb-1 block">
                    {card.category}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-background-50 leading-snug line-clamp-2 mb-1">
                    {card.title}
                  </h3>
                  <p className="text-xs text-background-50/60 line-clamp-1">
                    {card.summary}
                  </p>
                </div>
              </div>
              <div className="px-4 py-3 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{card.time}</span>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line text-xs"></i>
                  {card.reads}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}